import {
  AuthFormBoxInternalTemplate,
  AuthFormBoxRowGaps,
  PrimarySubmitButton,
} from '@setplex/arcana'
import { useForm } from 'effector-forms'
import { useUnit } from 'effector-react'
import type { JSX } from 'react'
import { type FormEvent } from 'react'
import { $signUpFormTranslations } from '../../translations'
import { signUpForm, signUpFx } from '../model'
import { UsernameAndPasswordInputs } from './UsernameAndPasswordInputs'

export const RegistrationByEmailForm = (): JSX.Element => {
  const formTranslations = useUnit($signUpFormTranslations)

  const { submit, eachValid } = useForm(signUpForm)

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    submit()
  }
  const pending = useUnit(signUpFx.pending)

  return (
    <form onSubmit={onSubmit} autoComplete='off' noValidate>
      <AuthFormBoxInternalTemplate rowGap={AuthFormBoxRowGaps.SIZE_190}>
        <UsernameAndPasswordInputs />
        <PrimarySubmitButton
          title={formTranslations.submitButton}
          disabled={pending || !eachValid}
          isLoading={pending}
        />
      </AuthFormBoxInternalTemplate>
    </form>
  )
}
